import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
	// eslint-disable-next-line @angular-eslint/directive-selector
	selector: '[clickOutside]',
})
export class ClickOutsideDirective {
	@Output()
	clickOutside: EventEmitter<boolean> = new EventEmitter();

	constructor(private elemRef: ElementRef) {}

	@HostListener('document:click', ['$event'])
	@HostListener('document:touchstart', ['$event'])
	toggle(event: Event) {
		if (!this.elemRef.nativeElement.contains(event.target)) {
			this.clickOutside.emit(true);
		}
	}
}
